import type { HttpRequestConfig, HttpResponse } from './types';

export interface TelemetryHttpInterceptor {
  request: (config: HttpRequestConfig) => HttpRequestConfig;
  response: (response: HttpResponse) => HttpResponse;
  responseError: (response: HttpResponse) => Promise<never>;
}

/**
 * $http interceptor stub — kept for backward compatibility with the AngularJS
 * telemetry module registration.
 *
 * Header injection is no longer needed here: the XHR.send wrapper in index.ts
 * sets the active page context before each request, so XMLHttpRequestInstrumentation
 * automatically creates correctly-parented spans and injects W3C trace headers.
 * propagateTraceHeaderCorsUrls: [/.* /] ensures headers are sent to ALL origins.
 */
export const telemetryHttpInterceptorFactory = (): TelemetryHttpInterceptor => {
  console.debug('[telemetry] HTTP interceptor created (header injection handled by XHR instrumentation)');

  return {
    request(config: HttpRequestConfig): HttpRequestConfig {
      return config;
    },

    response(response: HttpResponse): HttpResponse {
      return response;
    },

    responseError(response: HttpResponse): Promise<never> {
      return Promise.reject(response);
    }
  };
};